<template lang="pug">
.v-price.price(v-if="price" :class="['price--' + view, 'price--' + size]")
	template(v-if="view === 'modal' && price.currencies && price.currencies.length")
		template(v-for="(item, itemIndex) in price.currencies.filter(item => item.main)"
				:key="itemIndex")
			.price__group
				span.price__value(v-if="typeof(item.value) === 'number'") {{formatPrice(item.value)}}
				span.price__postfix(v-if="item.currency") &nbsp;{{item.currency}}&nbsp;
		.price__group-wrap
			template(v-for="(item, itemIndex) in price.currencies.filter(item => !item.main)"
					:key="itemIndex")
				.price__group.price__group--second
					span.price__prefix(v-if="item.prefix") {{item.prefix}}&nbsp;
					span.price__value(v-if="typeof(item.value) === 'number'") {{formatPrice(item.value)}}&nbsp;
					span.price__postfix(v-if="item.currency") {{item.currency}}
	template(v-else)
		.price__title-container
			v-svg-icon.price__icon(v-if="view2 === 'rate'" icon="rate")
			.price__title(v-if="price.title") {{price.title}}
		.price__groups
			v-svg-icon.price__icon(v-if="view === 'delivery'" icon="delivery-price")
			span.price__label(v-if="price.current.label") {{price.current.label}}&nbsp;
			.price__group(v-if="price.current" :class="{'price__group--clickable': price.current.arrow}" @click="handleClick")
				v-svg-icon.price__icon(v-if="view === 'rate'" icon="rate")
				span.price__prefix(v-if="price.current.prefix") {{price.current.prefix}}&nbsp;
				span.price__currency(v-if="price.current.currency && price.current.currency === '$'") {{price.current.currency}}&nbsp;
				span.price__value(v-if="typeof(price.current.value) === 'number'") {{formatPrice(price.current.value)}}
				span.price__value(v-if="typeof(price.current.value2) === 'number'") &nbsp;- {{formatPrice(price.current.value2)}}
				span.price__currency(v-if="price.current.currency && price.current.currency !== '$'") &nbsp;{{price.current.currency}}
				span.price__postfix(v-if="price.current.postfix") &nbsp;{{price.current.postfix}}&nbsp;
				v-svg-icon.price__arrow(v-if="price.current.arrow" icon="price-arrow")
			.price__group.price__group--second(v-if="price.second"
					:id="price.second.arrow ? 'price__group--clickable' : ''"
					:class="{'price__group--clickable': price.second.arrow, 'price__group--tooltip': price.second.tooltip, 'price__group--discount': price.second.discount}"
					@click="handleClick")
				span.price__prefix(v-if="price.second.prefix") {{price.second.prefix}}&nbsp;
				span.price__currency(v-if="price.second.currency && price.second.currency === '$'") {{price.second.currency}}&nbsp;
				span.price__value(v-if="typeof(price.second.value) === 'number'") {{formatPrice(price.second.value)}}&nbsp;
				span.price__currency(v-if="price.second.currency && price.second.currency !== '$'") {{price.second.currency}}&nbsp;
				span.price__postfix(v-if="price.second.postfix") {{price.second.postfix}}<sup v-if="price.second.star">*</sup>
				span.price__description(v-if="price.second.description") {{price.second.description}}
				v-svg-icon.price__arrow(v-if="price.second.arrow" icon="price-arrow")
				template(v-if="price.currencies && !isSm")
					.key-value-list__tooltip-wrapper.key-value-list__tooltip-wrapper--currencies
						.key-value-list__tooltip-container
							.key-value-list__tooltip.key-value-list__tooltip--currencies
								.key-value-list__tooltip-text.key-value-list__tooltip-text--currencies.scrollbar(v-html="getCurrenciesTooltipContent(price.currencies)")
				template(v-if="price.second.tooltip")
					.key-value-list__tooltip-wrapper
						template(v-if="isSm")
							v-svg-icon.key-value-list__tooltip-icon(icon="tooltip-icon"
								@click.stop="openTooltip(price.second.tooltip)")
						template(v-else)
							v-svg-icon.key-value-list__tooltip-icon(icon="tooltip-icon")
							.key-value-list__tooltip-container
								.key-value-list__tooltip
									.key-value-list__tooltip-text.scrollbar(v-if="price.second.tooltip" v-html="price.second.tooltip")
			.price__group(v-if="price.current2")
				span.price__hyphen &nbsp;-&nbsp;
				span.price__prefix(v-if="price.current2.prefix") {{price.current2.prefix}}&nbsp;
				span.price__currency(v-if="price.current2.currency && price.current2.currency === '$'") {{price.current2.currency}}&nbsp;
				span.price__value(v-if="typeof(price.current2.value) === 'number'") {{formatPrice(price.current2.value)}}&nbsp;
				span.price__currency(v-if="price.current2.currency && price.current2.currency !== '$'") {{price.current2.currency}}&nbsp;
				span.price__postfix(v-if="price.current2.postfix") {{price.current2.postfix}}
				v-svg-icon.price__arrow(v-if="price.current2.arrow" icon="price-arrow")
</template>

<script>
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		formattingMixin,
		isMobMixin
	],

	props: {
		price: {
			type: Object,
			default: null
		},

		view: {
			type: String,
			default: 'regular'
		},

		view2: {
			type: String,
			default: null
		},

		size: {
			type: String,
			default: 'md'
		},

		stopPropagation: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		handleClick(event) {
			if (this.price?.second?.tooltip && !this.price?.second?.arrow) {
				event.stopPropagation();
			} else if (this.price?.currencies && this.isSm) {
				event.stopPropagation();
				this.openCurrencies()
			} else if (this.price?.currencies && !this.isSm) {
				event.stopPropagation();
			} else {
				this.emitClick(event);
			}
		},

		getCurrenciesTooltipContent(currencies) {
			return currencies.map(item => {
				const className = item.main ? 'currencies__row--main' : '';
				return `
                <div class="currencies__tooltip">
                    <div class="currencies__row ${className}">${item.prefix || ''} ${this.formatPrice(item.value)} ${item.currency || ''}</div>
                </div>
            `;
			}).join('');
		},

		emitClick(e) {
			if (this.stopPropagation) {
				e.stopPropagation();
			}
			this.$emit('open-details', e);
		},

		openCurrencies() {
			controller.openModal({
					className: 'modal--sm',
					component: {
						name: 'v-price',
						props: {
							price: this.price,
							view: 'modal',
							className: 'price--currencies'
						}
					}
			})
		},

		openTooltip(text) {
			controller.openModal({
				className: 'modal--mid',
				content: `<v-modal-window>${text}</v-modal-window>`
			});
		},
	}
};
</script>
